import { guideCategories } from '../data/guide/categories'
import { guideEntries } from '../data/guide/entries'
import { guideFaqs } from '../data/guide/faqs'
import type { GuideCategory, GuideEntry, GuideFaq } from '../types/guide'

export const FAQ_CATEGORY_ID = 'soporte-faq'

const entryById = new Map(guideEntries.map((e) => [e.id, e]))
const categoryById = new Map(guideCategories.map((c) => [c.id, c]))

const kindLabels: Record<GuideEntry['kind'], string> = {
  item: 'Ítem',
  event: 'Evento',
  mechanic: 'Mecánica',
  map: 'Mapa',
  article: 'Guía',
}

export function getEntry(id: string): GuideEntry | undefined {
  return entryById.get(id)
}

export function getCategory(id: string): GuideCategory | undefined {
  return categoryById.get(id)
}

export function entriesInCategory(categoryId: string): GuideEntry[] {
  const list = guideEntries.filter((e) => e.categoryId === categoryId)
  return [...list.filter((e) => e.kind === 'article'), ...list.filter((e) => e.kind !== 'article')]
}

export function categoryCount(categoryId: string): number {
  return entriesInCategory(categoryId).length + (categoryId === FAQ_CATEGORY_ID ? guideFaqs.length : 0)
}

export const visibleCategories: GuideCategory[] = guideCategories.filter((c) => categoryCount(c.id) > 0 || c.comingSoon)

export function isCategoryPublished(categoryId: string): boolean {
  return categoryCount(categoryId) > 0
}

export function entryPath(entry: GuideEntry, sectionId?: string): string {
  const base = entry.customPath ?? `/guia/${entry.categoryId}/${entry.id}`
  return sectionId ? `${base}#${sectionId}` : base
}

export function entryPathById(id: string, sectionId?: string): string {
  const e = getEntry(id)
  return e ? entryPath(e, sectionId) : '/guia'
}

export function faqPath(faq: GuideFaq): string {
  return `/guia/${FAQ_CATEGORY_ID}#${faq.id}`
}

export function faqsForEntry(entryId: string): GuideFaq[] {
  return guideFaqs.filter((f) => f.related.some((r) => r.entryId === entryId))
}

export function entryKindLabel(entry: GuideEntry): string {
  return entry.kindLabel ?? kindLabels[entry.kind]
}

export { guideFaqs, guideEntries }
